
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech-support/[seoName]",
      function () {
        return require("private-next-pages/tech-support/[seoName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech-support/[seoName]"])
      });
    }
  